import { render, staticRenderFns } from "./NoFotoMan.vue?vue&type=template&id=ef5628ca&scoped=true&"
import script from "./NoFotoMan.vue?vue&type=script&lang=ts&"
export * from "./NoFotoMan.vue?vue&type=script&lang=ts&"
import style0 from "./NoFotoMan.vue?vue&type=style&index=0&id=ef5628ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef5628ca",
  null
  
)

export default component.exports